import CalendarToday from "@mui/icons-material/CalendarToday";
import SettingsIcon from "@mui/icons-material/Settings";
import Home from "@mui/icons-material/Home";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { resetAppointment } from "../../redux/actions";
import { Menu, Stack } from "@mui/material";
import { PRI_500, WARNING_500 } from "../../theme/colors";
import DrawerMenu from "../../pages/HomePage/components/DrawerMenu";

const useStyles = makeStyles(() => ({
  paper: {
    padding: "8px 16px",
    position: "fixed",
    bottom: "24px",
    left: "0",
    right: "0",
    margin: "0px 16px",
    zIndex: "100",
    borderRadius: "24px !important",
    width: "fit-content",
    border: "1px solid #000 !important",
  },
  paperRelative: {
    padding: "8px 16px",
    borderRadius: "24px !important",
    height: "100%",
  },
  disabled: {
    opacity: 0.5,
  },
}));
const BottomNav = (props) => {
  const {
    stateUser,
    stateBahasa,
    actResetAppointment,
    position = "absolute",
    stateToken
  } = props;
  const location = useLocation();
  const classes = useStyles();
  const navigate = useNavigate();
  const toHistory = () => {
    stateUser && navigate("/history");
  };

  const [menu, setMenu] = React.useState({
    title: "",
    icon: "",
    nav: "",
  });

  const [open, setopen] = React.useState({
    drawer: false,
  });

  const iconStyle = {
    // fontSize: "large",
    sx: {
      color: "#FFF",
    },
  };

  React.useEffect(() => {
    if (location && location.pathname === "/home") {
      setMenu({
        title: "Home",
        icon: <Home {...iconStyle} />,
        nav: "/home",
      });
    } else if (location && location.pathname === "/history") {
      setMenu({
        title: "History",
        icon: <CalendarToday {...iconStyle} />,
        nav: "/history",
      });
    }
    // else if (location && location.pathname === "/calendar") {
    //   setMenu({
    //     title: "Settings",
    //     icon: <SettingsIcon {...iconStyle} />,
    //     nav: "/calendar",
    //   });
    // }

    return () => {};
  }, [location]);

  return (
    <>
      <DrawerMenu
        open={open.drawer}
        setopen={(val) => setopen({ ...open, drawer: val })}
      />
      <Paper
        className={
          position === "relative" ? classes.paperRelative : classes.paper
        }
        variant="outlined"
      >
        <Stack spacing={1} direction="row">
          <Paper
            variant="outlined"
            sx={{
              display: "flex",
              alignItems: "center",
              padding: "8px 24px",
              borderRadius: "16px",
              gap: 1,
              border: "1px solid #000 !important",
              backgroundColor: WARNING_500,
              width: "90px",
            }}
            onClick={() => navigate(menu.nav)}
          >
            {menu.icon}
            <Typography
              variant="subtitle2"
              fontWeight="700"
              align="center"
              color="#FFF"
            >
              {menu.title}
            </Typography>
          </Paper>
          {location.pathname !== "/home" && (
            <IconButton onClick={() => navigate("/home")}>
              <Home />
            </IconButton>
          )}
          {location.pathname !== "/history" && (
            <IconButton
              disabled={stateToken === null}
              onClick={() =>
                stateUser.need_register
                  ? navigate("/history-pre-pasien")
                  : navigate("/history")
              }
            >
              <CalendarToday fontSize="small" />
            </IconButton>
          )}
          <IconButton
            onClick={() =>
              setopen({
                ...open,
                drawer: true,
              })
            }
          >
            <SettingsIcon fontSize="small" />
          </IconButton>
        </Stack>
      </Paper>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    stateBahasa: state.app.bahasa,
    stateUser: state.auth.user,
    stateToken: state.auth.token,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actResetAppointment: (body) => dispatch(resetAppointment(body)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BottomNav);
